import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const KitchenCard = ({ kitchen }) => (
  <Link
    to={`/kitchens/${kitchen.slug}`}
    data-testid={`kitchen-card-${kitchen.slug}`}
    className="group flex h-full flex-col overflow-hidden rounded-2xl border border-ink/10 bg-white shadow-sm transition-all duration-500 hover:-translate-y-1 hover:shadow-xl"
  >
    <div className="relative aspect-[4/3] overflow-hidden bg-sand">
      <img
        src={kitchen.image}
        alt={`${kitchen.name} — ${kitchen.category} by Paramount Kitchen, Kangra, Himachal Pradesh`}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
      />
      <span className="absolute left-4 top-4 rounded-full bg-ivory/90 px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.18em] text-royal backdrop-blur">
        {kitchen.category}
      </span>
    </div>
    <div className="flex flex-1 flex-col p-6">
      <h3 className="font-display text-2xl font-medium text-ink">{kitchen.name}</h3>
      <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-ink/60">
        {kitchen.description}
      </p>
      <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-royal">
        Explore Kitchen
        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
      </span>
    </div>
  </Link>
);
